import { Mail, MapPin, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/site/Navbar";
import { useSiteSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const { settings } = useSiteSettings();
  const email = settings?.contact_email || "admin@imtheplugnow.com";
  return (
    <footer className="border-t border-border bg-card" data-testid="site-footer">
      <div className="h-1 vibrant-bar" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5 space-y-4">
          <Logo />
          <p className="text-muted-foreground max-w-sm">A private, vetted network introducing serious bulk flower buyers to trusted California farms. Not a marketplace.</p>
        </div>
        <div className="md:col-span-4 space-y-3 text-sm">
          <p className="eyebrow text-muted-foreground">Reach us</p>
          <a href={`mailto:${email}`} className="flex items-center gap-2 font-semibold hover:text-primary transition-colors" data-testid="footer-contact-email">
            <Mail className="h-4 w-4" /> {email}
          </a>
          <p className="flex items-center gap-2 text-muted-foreground"><MapPin className="h-4 w-4" /> Distribution location, California</p>
        </div>
        <div className="md:col-span-3 space-y-3 text-sm">
          <p className="eyebrow text-muted-foreground">Our promise</p>
          <p className="flex items-start gap-2 text-muted-foreground"><ShieldCheck className="h-4 w-4 mt-0.5 text-primary" /> No online payments. Membership is paid in cash only after approval.</p>
        </div>
      </div>
      <p className="text-center text-xs text-muted-foreground pb-8">© {new Date().getFullYear()} I'm The Plug Now · imtheplugnow.com</p>
    </footer>
  );
};
